import type { FieldHelpContent } from "@/components/ui/field-help";

/** Sparse Contact / party help — plan/46. */
export const contactHelp = {
  roles: {
    title: "Roles",
    summary:
      "One contact can be a customer, a supplier, or both. Roles control which sales/purchase lists and statements they appear in.",
    example: "A wholesaler you both buy from and sell to → Customer + Supplier.",
    useCases: [
      "Flip roles on the full contact when they start buying or supplying.",
      "Person contacts under an org inherit context — roles still live on the party you sell/buy with.",
    ],
  },
  arOpen: {
    title: "AR open",
    summary:
      "Open accounts receivable — unpaid (or partially paid) sales invoices for this customer.",
    example: "₱12,000 AR open → collect from To collect or their Statement of account.",
    useCases: [
      "Glance before calling — know they still owe before promising credit.",
    ],
  },
  apOpen: {
    title: "AP open",
    summary:
      "Open accounts payable — unpaid (or partially paid) purchase invoices for this supplier.",
    example: "₱8,500 AP open → pay from To pay or clear against their statement.",
    useCases: [
      "Check before ordering more stock from the same supplier.",
    ],
  },
  people: {
    title: "People",
    summary:
      "Person contacts linked under this organization — buyers, APs, drivers you talk to by name.",
    example: "Acme Trading (org) → Maya (person) linked as purchasing contact.",
    useCases: [
      "Link people from the org’s full contact page after create.",
    ],
  },
} as const satisfies Record<string, FieldHelpContent>;
